import { render } from "./Strolers.vue?vue&type=template&id=c445bac2"
import script from "./Strolers.vue?vue&type=script&lang=js"
export * from "./Strolers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__